var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c(
            "div",
            { class: { "pre-scrollable": _vm.showButtons } },
            [_vm.$i18n.locale === "en" ? [_vm._m(0)] : [_vm._m(1)]],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.showButtons
        ? _c("div", { staticClass: "row text-center" }, [
            _c("div", { staticClass: "col-xs-6" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary btn-margin",
                  attrs: { role: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.accept($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("accept")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-secondary btn-margin",
                  attrs: { href: "https://www.gs1-germany.de/", role: "button" }
                },
                [_vm._v(_vm._s(_vm.$t("decline")))]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.errorState.length !== 0
        ? _c("gs1-alert", [_vm._v(_vm._s(_vm.errorState))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _c("strong", [_vm._v("General ")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  All products and services provided by GS1 Germany\n                  (hereinafter referred to as the “Provider”) in the context\n                  of Customer’s use of the Verified by GS1 application shall\n                  be made available solely on the basis of the following Terms\n                  of Use as last amended at the time of use. Unless otherwise\n                  agreed explicitly in writing, no deviating terms and\n                  conditions shall apply.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Customers in the context of these Terms of Use are\n                  exclusively operators. Within the meaning of the Terms of\n                  Use, these are natural or legal persons or partnerships with\n                  legal capacity who/which are exercising their commercial or\n                  independent professional activity at the time the Contract\n                  with the Provider is concluded.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Subject of the Contract")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The subject of the Contract is the provision of the\n                  application as an online version using a current and\n                  customary internet browser or an API.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The application may be made available by the Provider free\n                  of charge or subject to the payment of a fee. If using the\n                  application free of charge, the User shall not be entitled\n                  to expect the continued provision of individual functions of\n                  the application.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The Provider does not guarantee that the application will\n                  function error-free on all browsers. The application will\n                  only be optimised for the most commonly used browsers.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The use of the application requires the transfer of data via\n                  the internet. The User is responsible for this and shall\n                  bear any associated costs.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The Provider is entitled to use open source components\n                  within the application, to the extent that they do not\n                  impair the normal use of the application by the User in\n                  accordance with this Contract.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Conclusion of the Contract and user account")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The use of the application results in a contract for use\n                  between the User and the Provider in respect of the use of\n                  the application. If the User registers in the application,\n                  this shall result in a contractual relationship between the\n                  Provider and the User.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The condition for using the application is that the User\n                  registers by creating a user account in which their data are\n                  stored permanently. The registration consists of a user name\n                  and a password (“Login Data”). A user account can only be\n                  created if the User provides a current email address. This\n                  email address will also be used for communication with the\n                  Provider. There is no specific entitlement to being granted\n                  access to use the application.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The User is obliged to treat their Login Data with care. In\n                  particular, the User shall not share their Login Data with\n                  third parties and/or enable third parties to access their\n                  profile by circumventing the need for Login Data.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Should the User breach their obligations as set forth above\n                  and their user account be used by third parties, the User\n                  shall be liable for all activities performed with their user\n                  account. The User shall not be liable if they were not\n                  responsible for the misuse of their account.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The User warrants that the data used to create their profile\n                  (“Profile Data”) are complete and correct.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Obligations of the User")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The User shall be responsible for the security of their own\n                  data. The Provider assumes no liability for the loss of the\n                  data saved permanently by the User in the application.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Regarding the extent of the use of data, the GS1 Registry\n                  conditions of participation for data recipients shall apply.\n                  These can be viewed at\n                  "
            ),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Registry_Teilnahmebedingungen_fuer_Datenempfaenger.pdf"
                }
              },
              [_vm._v("GS1 Registry Teilnahmebedingungen")]
            ),
            _vm._v(".\n                ")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  In the event of any malfunction of the application and/or\n                  its functionalities, the User shall notify the Provider of\n                  such malfunction by email without undue delay. The same\n                  shall apply if the User receives information about content\n                  published by third parties that evidently breaches\n                  applicable law or third-party rights.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Rights of use")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The application and the content provided therein are\n                  protected by copyright. The Provider holds all rights.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The User shall receive a simple and non-transferable right\n                  that is restricted to the term of this Contract and allows\n                  use of the application in accordance with the terms and\n                  conditions.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The User shall not be entitled to any further uses. In\n                  particular, the User shall be prohibited from selling,\n                  renting, loaning or reproducing the application’s content,\n                  the application itself or parts thereof or from distributing\n                  its content and/or publishing this in any other way. The\n                  distribution and/or reproduction of any of the application’s\n                  content without the Provider’s consent are prohibited.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The User shall grant the Provider rights to use the data\n                  provided in the application that are necessary to execute\n                  the Contract. These include but are not restricted to the\n                  right to give access to the data via the internet in\n                  response to queries and especially to reproduce and transmit\n                  these data as well as to reproduce the data for the purposes\n                  of data security.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Fee")]),
        _c("br"),
        _vm._v(
          "\n              After successful registration, you can use Verified by GS1\n              without restrictions during a free trial period. We reserve the\n              right to offer the service for a fee in the future. We will\n              inform you of any changes in due course.\n            "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Availability")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Adjustments, amendments and additions to the contractual\n                  services as well as measures to identify and remedy any\n                  malfunctions shall only result in a temporary interruption\n                  to or impairment of accessibility if this is essential for\n                  technical reasons.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The Provider aims to ensure average annual availability of\n                  the application of 98.5%. Planned and communicated\n                  maintenance work shall not be deemed failure time. The\n                  Provider shall endeavour to communicate maintenance work at\n                  least seven (7) days in advance.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Force majeure")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The Provider shall be released from its obligation to\n                  execute this Contract if the non-performance of services is\n                  due to the occurrence of force majeure after conclusion of\n                  the Contract.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Such force majeure shall include, for example, war, strikes,\n                  unrest, pandemics, expropriations, substantial changes in\n                  law, storms, floods and other natural catastrophes as well\n                  as any other circumstances for which the Provider shall not\n                  be held responsible, especially the ingress of water, power\n                  cuts, disruption to or destruction of data lines or\n                  infrastructure and hacker attacks that could not have been\n                  prevented even by taking security measures that are\n                  customary for the industry.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Each Party shall notify the other Party in writing and\n                  without undue delay of the occurrence of force majeure.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Limitation of liability")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The Provider shall be liable without limitation for wilful\n                  intent or gross negligence. However, in the case of slight\n                  negligence, it shall be liable only for any breach of\n                  material contractual obligations. These shall include those\n                  obligations that are necessary for the proper execution of\n                  the Contract, compliance with which is and may be relied\n                  upon by the Parties. Liability in the event of a breach of\n                  such material contractual obligations shall be limited to\n                  damages typical for such contracts, the occurrence of which\n                  the Provider must anticipate upon conclusion of the Contract\n                  on the basis of the circumstances known at that time.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The aforementioned exclusion of liability shall not apply to\n                  injuries to life, limb or health. Liability in accordance\n                  with product liability legislation shall not be affected.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The Provider assumes no liability for any network faults for\n                  which it is not responsible.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  In the event of a loss of data, the Provider shall only be\n                  liable as set forth above if such loss of data would not\n                  have been avoidable had the User taken appropriate data\n                  security measures.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The Provider shall not be liable for impairments caused by\n                  improper or incorrect use by the User.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The limitations of liability set forth above shall also\n                  apply mutatis mutandi to the Provider’s agents.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  If the application provides the option of redirection to\n                  third-party databases, websites, interfaces or services,\n                  e.g. by the provision of links or hyperlinks, the Provider\n                  shall not be liable for the accessibility, continued\n                  existence or security of these databases or services nor for\n                  their content. In particular, the Provider shall not be\n                  liable for their legality or for the accuracy, completeness\n                  or validity of their content.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Data protection")]),
        _c("br"),
        _vm._v(
          "\n              The User may find information about the processing of personal\n              data in the Provider’s privacy policy. This can be accessed at\n              "
        ),
        _c(
          "a",
          { attrs: { href: "https://www.gs1-germany.de/datenschutz/" } },
          [_vm._v("Datenschutzinformationen")]
        ),
        _vm._v(".\n            ")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Term of the Contract, notice of termination")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The term of the Contract and the notice periods are defined\n                  in the respective product description which can be accessed\n                  at\n                  "
            ),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Germany_Leistungsbeschreibung_VbGS1_.pdf"
                }
              },
              [_vm._v("Produktbeschreibung")]
            ),
            _vm._v(".\n                ")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Upon termination of the Contract, the User shall have no\n                  further access to the services covered by this Contract.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  This shall not affect the rights of the Parties of\n                  extraordinary termination for cause which shall exist\n                  especially if:\n                  "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                      a Party repeatedly breaches material contractual\n                      obligations, despite a formal warning to desist;\n                    "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                      a Party acts illegally in connection with this Contract;\n                    "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                      one of the Parties ceases operation in whole or in part\n                      and its continued operation is not guaranteed by a\n                      direct legal successor.\n                    "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The notice of termination must be made in writing. An email\n                  is sufficient.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Upon termination of the Contract, irrespective of the\n                  reason, the User’s contractual rights of use shall end.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Miscellaneous, final provisions")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  The law of the Federal Republic of Germany shall apply. The\n                  exclusive jurisdiction for disputes arising from this\n                  Contract shall be Cologne, Germany.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The Contract language is German. Should translations of the\n                  Contract contradict the German version, the latter shall\n                  have precedence.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  No oral side agreements have been made. Amendments to this\n                  Contract shall only be valid if agreed by the Parties in\n                  writing. This shall also apply to any amendment of the\n                  written form requirement.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Should a provision of this Contract be or become invalid,\n                  this shall not affect the validity of the remaining\n                  provisions of the Contract.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  The User waives compliance with the obligations in respect\n                  of e-commerce pursuant to Section 312i (1) sentence 1 No. 1\n                  to 3 and sentence 2 of the German Commercial Code (BGB).\n                "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _c("strong", [_vm._v("Allgemeines")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Sämtliche Lieferungen und Leistungen von GS1 Germany\n                  (nachfolgend „Anbieter“), die dem Kunden im Rahmen der\n                  Anwendung „Verified by GS1“ zur Verfügung gestellt werden,\n                  erfolgen ausschließlich auf der Grundlage der nachfolgenden\n                  Nutzungsbedingungen in ihrer zum Zeitpunkt der Nutzung\n                  gültigen Fassung. Sofern nicht ausdrücklich schriftlich\n                  vereinbart, finden abweichende Geschäftsbedingungen keine\n                  Anwendung.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Kunde im Sinne dieser Geschäftsbedingungen sind\n                  ausschließlich Unternehmer. Im Sinne der\n                  Geschäftsbedingungen sind dies natürliche oder juristische\n                  Personen oder rechtsfähige Personengesellschaften, die bei\n                  Vertragsschluss mit dem Anbieter in Ausübung ihrer\n                  gewerblichen oder selbständigen beruflichen Tätigkeit\n                  handeln.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Nutzungsgegenstand")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Vertragsgegenstand ist die Bereitstellung der Anwendung in\n                  der Webversion unter Verwendung eines aktuellen und gängigen\n                  Internetbrowsers sowie per API.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Die Bereitstellung der Anwendung durch den Anbieter kann auf\n                  kostenfreier oder kostenpflichtiger Basis erfolgen. Bei\n                  kostenfreier Nutzung besteht kein Anspruch des Nutzers auf\n                  Aufrechterhaltung einzelner Funktionalitäten der Anwendung.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Anbieter gewährleistet nicht, dass die Anwendung auf\n                  jedem Browser fehlerfrei funktioniert. Die Optimierung der\n                  Anwendung erfolgt lediglich für die gängigsten Browser.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Die Nutzung der Anwendung erfordert eine Datenübertragung\n                  über das Internet, wobei der Nutzer für diese verantwortlich\n                  ist und die hierfür entstehenden Kosten selbst trägt.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Anbieter ist berechtigt, innerhalb der Anwendung Open\n                  Source Bestandteile zu verwenden, soweit sie der\n                  gewöhnlichen Verwendung der Anwendung durch den Nutzer nach\n                  dieser Vereinbarung nicht entgegenstehen.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Vertragsschluss und Nutzerkonto")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Durch die Nutzung der Anwendung kommt ein Nutzungsvertrag\n                  zwischen dem Nutzer und dem Anbieter über die Nutzung der\n                  Anwendung zustande. Registriert sich der Nutzer in der\n                  Anwendung, kommt insoweit ein Vertragsverhältnis zwischen\n                  dem Anbieter und dem Nutzer zustande.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Voraussetzung der Nutzung der Anwendung ist die\n                  Registrierung des Nutzers mit Erstellung eines Nutzerkontos,\n                  in dem die Daten des Nutzers dauerhaft gespeichert werden.\n                  Die Registrierung besteht aus einem Usernamen und einem\n                  Kennwort („Login-Daten“). Die Erstellung eines Nutzerkontos\n                  ist nur unter Angabe einer aktuellen E-Mail-Adresse des\n                  Nutzers möglich. Diese E-Mail-Adresse dient zugleich der\n                  Kommunikation mit dem Anbieter. Ein konkreter Anspruch auf\n                  Zulassung zur Nutzung der Anwendung besteht nicht.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Nutzer ist verpflichtet, mit den Login-Daten sorgfältig\n                  umzugehen. Insbesondere ist es dem Nutzer untersagt, die\n                  Login-Daten Dritten mitzuteilen und/oder Dritten den Zugang\n                  zu dem Profil unter Umgehung der Login-Daten zu ermöglichen.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Wenn der Nutzer seine Verpflichtungen gemäß vorstehender\n                  Ziffer verletzt und sein Nutzerkonto von Dritten verwendet\n                  wird, haftet der Nutzer für sämtliche Aktivitäten, die unter\n                  Verwendung seines Nutzerkontos stattfinden. Der Nutzer\n                  haftet nicht, wenn er den Missbrauch seines Nutzerkontos\n                  nicht zu vertreten hat.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Nutzer sichert zu, dass die bei Erstellung seines\n                  Profils verwendeten Daten („Profil-Daten“) vollständig und\n                  richtig sind.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Pflichten des Nutzers")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Der Nutzer trägt für die Sicherung seiner Daten selbst\n                  Sorge. Der Anbieter übernimmt keine Gewähr für den Verlust\n                  der dauerhaft durch den Nutzer innerhalb der Anwendung\n                  gespeicherten Daten.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Für den Umfang der Datennutzung gelten die GS1 Registry\n                  Teilnahmebedingungen für Datenempfänger, abrufbar unter\n                  "
            ),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Registry_Teilnahmebedingungen_fuer_Datenempfaenger.pdf"
                }
              },
              [_vm._v("GS1 Registry Teilnahmebedingungen")]
            ),
            _vm._v(".\n                ")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Sollte es bei der Nutzung der Anwendung bzw. ihrer\n                  Funktionalitäten zu Störungen kommen, wird der Nutzer den\n                  Anbieter von dieser Störung unverzüglich per E-Mail in\n                  Kenntnis setzen. Gleiches gilt, wenn der Nutzer\n                  Informationen über von Dritten veröffentlichte Inhalte\n                  erlangt, die offensichtlich gegen geltendes Recht oder\n                  Rechte Dritter verstoßen.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Nutzungsrechte")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Die Anwendung und die darin bereitgestellten Inhalte sind\n                  urheberrechtlich geschützt. Sämtliche Rechte liegen beim\n                  Anbieter.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Nutzer erhält das einfache, nicht übertragbare, auf die\n                  Laufzeit dieses Nutzungsvertrages zeitlich beschränkte\n                  Recht, die Anwendung bestimmungsgemäß zu nutzen.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Weitergehende Nutzungen sind dem Nutzer nicht gestattet. Es\n                  ist dem Nutzer insbesondere untersagt, Inhalte aus der\n                  Anwendung, die Anwendung oder Teile davon zu vertreiben, zu\n                  vermieten, zu verleihen, zu vervielfältigen oder ihre\n                  Inhalte zu verbreiten und/oder sonst zu veröffentlichen. Die\n                  Verbreitung und/oder öffentliche Wiedergabe von jedweden\n                  Inhalten der Anwendung ohne Einwilligung des Anbieters ist\n                  untersagt.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Nutzer räumt dem Anbieter die zur Durchführung des\n                  Vertrages notwendigen Nutzungsrechte an den Daten ein, die\n                  er in die Anwendung überträgt. Hierzu zählt insbesondere das\n                  Recht, die Daten bei Abfragen über das Internet zugänglich\n                  machen zu dürfen und insbesondere sie hierzu vervielfältigen\n                  und übermitteln sowie zum Zwecke der Datensicherung\n                  vervielfältigen zu dürfen.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Vergütung")]),
        _c("br"),
        _vm._v(
          "\n              Nach erfolgreicher Registrierung können Sie Verified by GS1 im\n              Rahmen einer kostenfreien Testphase uneingeschränkt nutzen. Wir\n              behalten uns das Recht vor, den Service in Zukunft\n              kostenpflichtig anzubieten. Alle Änderungen werden wir Ihnen\n              rechtzeitig mitteilen.\n            "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Verfügbarkeit")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Anpassungen, Änderungen und Ergänzungen der\n                  vertragsgegenständlichen Leistungen sowie Maßnahmen, die der\n                  Feststellung und Behebung von Funktionsstörungen dienen,\n                  werden nur dann zu einer vorübergehenden Unterbrechung oder\n                  Beeinträchtigung der Erreichbarkeit führen, wenn dies aus\n                  technischen Gründen zwingend notwendig ist.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Anbieter strebt eine Verfügbarkeit der Anwendung von\n                  98,5% im Jahresmittel an. Geplante und angekündigte\n                  Wartungsarbeiten gelten nicht als Ausfallzeiten. Der\n                  Anbieter wird sich bemühen, Wartungsarbeiten mindestens 7\n                  Tage vor deren Beginn anzukündigen.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Höhere Gewalt")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Der Anbieter ist von der Verpflichtung zur Leistung aus\n                  diesem Vertrag befreit, soweit die Nichterfüllung von\n                  Leistungen auf das Eintreten von Umständen höherer Gewalt\n                  nach Vertragsabschluss zurückzuführen ist.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Als Umstände höherer Gewalt gelten zum Beispiel Krieg,\n                  Streiks, Unruhen, Pandemien, Enteignungen, kardinale\n                  Rechtsänderungen, Sturm, Überschwemmungen und sonstige\n                  Naturkatastrophen sowie sonstige von Anbieter nicht zu\n                  vertretende Umstände, insbesondere Wassereinbrüche,\n                  Stromausfälle, Unterbrechungen oder Zerstörung\n                  datenführender Leitungen oder Infrastruktur sowie\n                  Hackerangriffe, die auch mit branchenüblichen\n                  Sicherungsmaßnahmen nicht vermeidbar waren.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Jede Vertragspartei hat die andere Vertragspartei über den\n                  Eintritt eines Falles von höherer Gewalt unverzüglich\n                  schriftlich in Kenntnis zu setzen.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Haftungsbeschränkung")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Der Anbieter haftet für Vorsatz und grobe Fahrlässigkeit\n                  uneingeschränkt, für leichte Fahrlässigkeit jedoch nur bei\n                  der Verletzung vertragswesentlicher Pflichten. Als\n                  vertragswesentliche Pflichten gelten solche Pflichten, deren\n                  Erfüllung die ordnungsgemäße Vertragsdurchführung erst\n                  ermöglicht und auf deren Einhaltung der Vertragspartner\n                  vertraut und auch vertrauen darf. Die Haftung bei Verletzung\n                  einer solchen vertragswesentlichen Pflicht ist auf den\n                  vertragstypischen Schaden begrenzt, mit dessen Entstehen\n                  Anbieter bei Vertragsabschluss aufgrund der zu diesem\n                  Zeitpunkt bekannten Umstände rechnen musste.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Die vorstehenden Haftungsausschlüsse gelten nicht bei\n                  Verletzung von Leben, Körper und Gesundheit. Die Haftung\n                  nach dem Produkthaftungsgesetz bleibt unberührt.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Für vom Anbieter nicht verschuldete Störungen innerhalb des\n                  Leitungsnetzes übernimmt der Anbieter keine Haftung.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Für den Verlust von Daten haftet der Anbieter nach Maßgabe\n                  der vorstehenden Absätze nur dann, wenn ein solcher Verlust\n                  durch angemessene Datensicherungsmaßnahmen seitens des\n                  Nutzers nicht vermeidbar gewesen wäre.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Anbieter haftet nicht für Beeinträchtigungen, die durch\n                  eine unsachgemäße oder fehlerhafte Inanspruchnahme durch den\n                  Nutzer verursacht worden sind.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Die vorstehenden Haftungsbeschränkungen gelten sinngemäß\n                  auch zugunsten der Erfüllungsgehilfen des Anbieters.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Soweit über die Anwendung eine Möglichkeit der Weiterleitung\n                  auf Datenbanken, Websites, Schnittstellen oder Dienste\n                  Dritter, z. B. durch die Einstellung von Links oder\n                  Hyperlinks gegeben ist, haftet der Anbieter weder für\n                  Zugänglichkeit, Bestand oder Sicherheit dieser Datenbanken\n                  oder Dienste, noch für den Inhalt derselben. Insbesondere\n                  haftet der Anbieter nicht für deren Rechtmäßigkeit,\n                  inhaltliche Richtigkeit, Vollständigkeit, Aktualität.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Datenschutz")]),
        _c("br"),
        _vm._v(
          "\n              Alle Informationen zur Verarbeitung personenbezogener Daten kann\n              der Nutzer der Datenschutzerklärung vom Anbieter entnehmen.\n              Diese ist unter\n              "
        ),
        _c(
          "a",
          { attrs: { href: "https://www.gs1-germany.de/datenschutz/" } },
          [_vm._v("Datenschutzinformationen")]
        ),
        _vm._v(".\n            ")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Vertragsdauer, Kündigung")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Die Laufzeit des Vertrages sowie die Kündigungsfristen\n                  ergeben sich aus der jeweiligen Produktbeschreibung,\n                  abrufbar unter\n                  "
            ),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Germany_Leistungsbeschreibung_VbGS1_.pdf"
                }
              },
              [_vm._v("Produktbeschreibung")]
            ),
            _vm._v(".\n                ")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Mit Beendigung des Vertrages hat der Nutzer keinen Zugriff\n                  mehr auf die unter diesem Vertrag vereinbarten Leistungen.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Das Recht der Parteien zur außerordentlichen Kündigung aus\n                  wichtigem Grund bleibt unberührt. Ein wichtiger Grund für\n                  eine außerordentliche Kündigung liegt insbesondere vor, wenn\n                  "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                      eine Partei wiederholt gegen vertragswesentliche\n                      Pflichten aus diesem Vertrag trotz Abmahnung verstößt;\n                    "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                      eine Partei im Zusammenhang mit diesem Vertrag eine\n                      deliktische Handlung begeht;\n                    "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                      eine der Parteien den Geschäftsbetrieb ganz oder\n                      teilweise einstellt, und der Weiterbetrieb nicht durch\n                      einen unmittelbaren Rechtsnachfolger gesichert ist.\n                    "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Die Kündigung hat in Textform zu erfolgen. Eine E-Mail ist\n                  ausreichend.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Mit der Beendigung des Vertrages, gleich aus welchem Grund,\n                  enden die vertraglichen Nutzungsbefugnisse des Nutzers.\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Sonstiges, Schlussbestimmungen")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n                  Es gilt das Recht der Bundesrepublik Deutschland. Für\n                  Streitigkeiten aus diesem Vertrag ist ausschließlicher\n                  Gerichtsstand Köln.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Die Vertragssprache ist deutsch. Sollten Übersetzungen des\n                  Vertrages der deutschen Fassung widersprechen, hat diese\n                  stets Vorrang.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Mündliche Nebenabreden sind nicht getroffen. Änderungen\n                  dieses Vertrages haben nur Gültigkeit, wenn sie zwischen den\n                  Vertragsparteien schriftlich vereinbart werden. Dies gilt\n                  auch für die Änderung der Schriftformklausel selbst.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Sollte eine Bestimmung dieses Vertrages unwirksam sein oder\n                  werden, so berührt dies die Wirksamkeit des Vertrages im\n                  Übrigen nicht.\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                  Der Nutzer verzichtet auf die Erfüllung der Pflichten im\n                  elektronischen Geschäftsverkehr nach § 312 i Abs. 1 Satz 1\n                  Nr. 1 – 3 und Satz 2 BGB.\n                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ac6fcf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac6fcf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/TermsOfUse.vue
// module id = null
// module chunks = 